import React from 'react';
import {Button, Row, Col} from 'antd';
import {marginBottom, marginTop} from "../../common/script";


export default class AboutUsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }


    render() {
        return (<div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs-about-us-banner.png'} alt={'zs-about-us-banner'}
                         className={'width100p'}></img>
                    <div className={'width100p first-context font-size64 text-center'} style={marginTop(10)}>
                        <span className={'colorfff'}>Make Business Even Closer</span>
                    </div>
                </div>
                <div className={'font-size64 color1E170B text-center'} style={marginTop(12)}>About Us</div>
                <Row style={marginTop(7)} >
                    <Col span={8} offset={4} className={'font-size24 color0D182B bg-f5f7fa flex-row'} style={{display:'flex'}}>
                        <div style={{padding:'0 48px'}}>
                            ZEUS Supply Chain brings professional logistics solution for clients from different industries,
                            with combining modern software and dedicated service, we brings accountability, transparency,
                            and peace of mind to your supply chain.
                        </div>
                    </Col>
                    <Col span={8}>
                        <img src={'https://qiniu.mrcargo.com/zs-about-us-word.png'} width={'100%'}
                             alt={'zs-about-us-word'}/>
                    </Col>
                </Row>
                <div style={Object.assign({background:'#0D182B'},marginTop(12))} className={'flex-col justify-center'}>
                    <div className={'font-size20 colorfff text-center'} style={marginTop(7)}>
                        <div>Professional customer service personnel and operators with rich logistics experience can
                            provide customers with customs
                        </div>
                        <div>clearance, transportation, distribution, one-stop service and value-added services.</div>
                    </div>
                    <Button type="primary" className={'concat-btn'} style={Object.assign(marginTop(5), marginBottom(7))}
                            size={'large'} onClick={() => {
                        this.props.navigationRoute('/concatUs')
                    }}>Need to contract</Button>
                </div>
            </div>
        );
    }

}






